import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import AnimatedTableChevron from 'src/components/AnimatedTableChevron/AnimatedTableChevron'
import { BudgetRequestListModel } from 'src/models/budgetRequest.models'
import Lnk from 'src/navigation/Lnk'
import { updateBudgetRequestUrl } from 'src/navigation/urls'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { css } from 'styled-components'

interface BudgetRequestsTableSmallProps {
  budgetRequests: BudgetRequestListModel[]
  isSlim: boolean
  isApprover?: boolean
}

const BudgetRequestsTableSmall: React.FC<BudgetRequestsTableSmallProps> = (
  props,
): React.ReactElement => {
  const users = useSelector(selectUserListModelsFromState)

  return (
    <div>
      {props.budgetRequests.map((budgetRequest, i) => {
        const user = props.isApprover
          ? budgetRequest.requester
          : budgetRequest.approver
        const displayUser = users[user.id] || user

        return (
          <Lnk
            to={updateBudgetRequestUrl(budgetRequest.id)}
            key={i}
            css={css`
              padding: 18px 20px;
              display: flex;
              flex-direction: column;
              min-height: 60px;
              border-top: 1px solid transparent;

              &:hover {
                background-color: ${styleConstants.colors.blue_opacity};

                .animated-table-chevron {
                  transform: translateX(4px);
                }
              }

              &:last-child {
                border-bottom: 1px solid ${styleConstants.colors.gray_light};
              }
            `}
            ariaLabelSource={'Account Overview'}
          >
            <div
              css={css`
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
                align-items: center;
              `}
            >
              <div
                css={css`
                  display: flex;
                  min-width: 0;
                `}
              >
                <img
                  css={css`
                    height: 20px;
                  `}
                  src={budgetRequest.budgetTypeImageSrc}
                  alt={''}
                />
                <div
                  css={css`
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                  `}
                >
                  <span
                    css={css`
                      ${getFontCss(
                        14,
                        themeConstants.colors.font_primary,
                        styleConstants.fontFamilies.medium,
                      )};
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin-bottom: 4px;
                    `}
                  >
                    {budgetRequest.displayName}
                  </span>
                  {!props.isSlim && (
                    <span
                      css={css`
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        ${getFontCss(
                          14,
                          styleConstants.colors.gray_darkest,
                          styleConstants.fontFamilies.regular,
                        )};
                      `}
                    >
                      {displayUser.truncatedFullNameOrEmail}
                    </span>
                  )}
                </div>
              </div>
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
              >
                <span
                  css={css`
                    margin-right: 30px;
                    ${getFontCss(
                      14,
                      themeConstants.colors.highlight,
                      styleConstants.fontFamilies.regular,
                    )};
                  `}
                >
                  {budgetRequest.issuedAmountLabel}
                </span>
                <AnimatedTableChevron />
              </div>
            </div>
          </Lnk>
        )
      })}
    </div>
  )
}

export default BudgetRequestsTableSmall
